import { render } from "./FeatureIndex.vue?vue&type=template&id=4d7aa7e6&ts=true"
import script from "./FeatureIndex.vue?vue&type=script&lang=ts"
export * from "./FeatureIndex.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__